<template>
  <div class="chat-item" :class="{ 'selected': room._id === chosenID, 'favourite': isMyFavRoom(room) }">
    <div class="icon" v-if="section === 'fav'">
      <img class="photo" @click="$emit('removeFav', { room })" v-if="isMyFavRoom(room)" src="../img/remove-fav.svg" alt="">
      <img class="photo" @click="$emit('addFav', { room })" v-if="!isMyFavRoom(room)" src="../img/add-fav.svg" alt="">
    </div>
    <div class="icon" v-if="section === 'others'">
      <img class="photo" @click="$emit('removeFav', { room }); $forceUpdate()" v-if="isMyFavRoom(room)" src="../img/solid-heart-minus-dark.svg" alt="">
      <img class="photo" @click="$emit('addFav', { room }); $forceUpdate()" v-if="!isMyFavRoom(room)" src="../img/add-fav.svg" alt="">
    </div>
    <div class="text" @click="$emit('select', room)">
      <div class="name" >
        <b>{{ room.title }}</b>
      </div>
      <!-- <div class="favourite">{{ room.favourite ? 'My Room' : 'Other rooms' }}</div> -->
      <div class="desc" >{{ room.desc }}</div>
    </div>
  </div>
</template>

<script>
import { API } from '@/yoteach2-gui/parts/index.js'

export default {
  props: {
    section: {
      default: 'auto'
    },
    chosenID: {},
    room: {}
  },
  methods: {
    isMyFavRoom (room) {
      return API.Status.state.favRooms.map(e => e.title).includes(room.title)
    }
  }
}
</script>

<style scoped>
.chat-item{
  display: flex;
  height: 80px;
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.34901960784313724) inset;
}
.chat-item.selected{
  background-color: rgb(255, 208, 208);
}
.favourite.chat-item{
  background-color: white;
}
.favourite.chat-item.selected{
  background-color: rgb(255, 208, 208);
}
.icon{
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  transition: transform 0.3s ease-in-out;
}

@media screen and (min-width: 767px) {
  .icon:hover{
    transform: scale(1.5);
  }
}
.photo{
  /* border-radius: 50%; */
  width: 24px;
  /* box-shadow: 0px 0px 10px 0px white; */
}
.text{
  width: calc(100% - 80px - 3px);
  margin-left: 3px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 12px;
  word-break: break-word;
  line-height: 18px;
}
.name{
  font-size: 14px;
}
.desc{
  font-size: 10px;
}
@media screen and (min-width: 767px) {
  .text:hover, .name:hover, .desc:hover{
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
